module.exports = __webpack_public_path__ + "static/media/np_user_-22.558c0331.svg";